// EffectGenerationAttemptStatus represents a status of effect generation session.
export const EffectGenerationAttemptStatus = {
  Created: "created",
  Processing: "processing",
  EffectGenerated: "effect_generated",
  EffectSelectedBySponsor: "effect_selected",
  EffectRejectedBySponsor: "effect_rejected",
  EffectSent: "effect_sent",
  EffectGenerationError: "effect_generation_error",
  BannedWordsFound: "banned_words_found",
  UnrecognizedError: "unrecognized_error",
};

Object.freeze(EffectGenerationAttemptStatus);

// EffectGenerationAttempt represents a session of effect generation.
export default class EffectGenerationAttempt {
    constructor(data) {
        this.uuid = data.uuid;
        this.status = data.status;
        this.prompt = data.prompt;
        this.stylePresetID = data.style_preset_id;
        this.generatedImageURL = data.generated_image_url;
    }
}
